
import Vue from 'vue'

import RatingControlIndicator from './RatingControlIndicator.vue'
import range from '@/common/utils/range'
import withinBounds from '@/common/utils/withinBounds'
import getXY from '@/common/utils/getXY'

type Color = { r: number; g: number; b: number }

const coldColor = { r: 67, g: 153, b: 162 }
const warmColor = { r: 156, g: 58, b: 37 }
const greyColor = { r: 59, g: 59, b: 59 }

const min = Math.min()
const rgb = ({ r, g, b }) => `rgb(${r | 0},${g | 0},${b | 0})`

const mixColors = (c1: Color, c2: Color) => {
  const mix = dist => (n1, n2) => n1 + dist * (n2 - n1)
  return (zeroToOne: number) => {
    const c = mix(zeroToOne)
    return rgb({
      r: c(c1.r, c2.r),
      g: c(c1.g, c2.g),
      b: c(c1.b, c2.b),
    })
  }
}
const colorMix = mixColors(coldColor, warmColor)

export default Vue.extend({
  data: () => ({
    left: null as null | Number,
  }),
  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    title: String,
    maxValue: Number,
    minValue: Number,
    maxLabel: String,
    minLabel: String,
    value: Number,
    active: Boolean,
  },
  computed: {
    scale: function() {
      return this.$refs.scale as Element
    },
    color() {
      if (typeof this.left === 'number') {
        return colorMix(this.percent)
      } else {
        return rgb(greyColor)
      }
    },
    percent() {
      return typeof this.left === 'number'
        ? this.left / this.scale.clientWidth
        : 0.5
    },
    runningValue() {
      const { minValue, maxValue } = this

      return (minValue + (maxValue - minValue) * this.percent) | 0
    },
  },
  methods: {
    onMove(e) {
      if (this.active) {
        const { clientX } = getXY(e)
        const { width, left } = this.scale.getBoundingClientRect()
        const l = withinBounds(1)((clientX - left) / width) * width
        this.left = l - (l % 6)
      }
    },
    onTouch(e) {
      if (this.active) {
        this.onMove(e)
        this.$emit('change', this.runningValue)
      }
    },
  },
  components: {
    RatingControlIndicator,
  },
  mounted() {
    const left = this.scale.clientWidth * 0.5
    this.left = left - (left % 6)
  },
})
